/** @jsx h */
import { h } from 'preact'
const baseClasses = 'flex-grow-1 flex flex-column content-stretch'

export default props => {
  return (
    <main
      {...Object.assign({}, props, {
        className: `${baseClasses} ${props.className || ''}`
      })}
    >
      <div className='flex-grow-1'>{props.children}</div>
    </main>
  )
}
